import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close_white.svg'


const _withScopeId = n => (_pushScopeId("data-v-4c9529e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = {
  key: 1,
  class: "modal"
}
const _hoisted_3 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_4 = {
  key: 0,
  class: "overlay"
}
const _hoisted_5 = {
  key: 1,
  class: "lds-ring"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "modal-header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  alt: "close",
  src: _imports_0
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "modal-body" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { id: "ul-modules-progress" }
const _hoisted_17 = { class: "module-title" }
const _hoisted_18 = { class: "module-progress-wrapper" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModuleProgressBar = _resolveComponent("ModuleProgressBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showProgressModal)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.showProgressModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.showProgressModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                  : _createCommentVNode("", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.$t("HEADER.PROGRESS.TITLE")), 1),
                  _createElementVNode("button", {
                    class: "btn",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                  }, _hoisted_13)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    (_ctx.treatmentSet)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                          _createElementVNode("ul", _hoisted_16, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (module, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, [
                                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.getModuleTitle(module, _ctx.user.language)), 1),
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_ModuleProgressBar, {
                                    progress: module.state.progress
                                  }, null, 8, ["progress"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.treatmentSet)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                          _createTextVNode(_toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_1")) + " ", 1),
                          _hoisted_20,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("HOME.TREATMENT_NOT_SET_2")) + " ", 1),
                          _hoisted_21,
                          _hoisted_22,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("HEADER.HELP.URGENT")), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}